var map = {
	"./BARBARA-HARRISON-min-scaled.jpg": 7801,
	"./BEVERLY-BOATWRIGHT-min-scaled.jpg": 3742,
	"./NATALIE-MONTGOMERY-min-scaled.jpg": 1437,
	"./pastor.jpeg": 7225,
	"./pastor1.jpg": 5181,
	"./prostate_2023.JPG": 469,
	"./vbs_header.png": 8040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 806;